import React, {
  Component
} from 'react';
import * as Config from '../config/Config'; 

export default class Homefooter extends Component {

  render() {
    return (
     <footer>
       <div className="f-btm">
         <div className="row">
           <p>1st Floor, 10-Sathya Gardens, Kamarajar Nagar, 80-feet Road, Saligramam, Chennai – 600093, Tamil Nadu, INDIA</p>
           <p> Mobile : +91 9176679710  -  Phone : +91 44-39361361  -  Email : info@361dm.com - Courses site : <a href={`${Config.rootDomainUrl}`}> www.361online.com</a> </p>
           <ul className="links">
             <li><a href={`${Config.onLineUrl}network/`}>Partners</a></li>
             <li><a href={`${Config.rootDomainUrl}institutions/`}>Institutions</a></li>
             <li><a href={`${Config.rootDomainUrl}corporates/`}>Corporates</a></li>
             <li><a href={`${Config.rootDomainUrl}asps/`}>ASPs</a></li>
             <li><a href={`${Config.rootDomainUrl}governments/`}>Governments</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/get-app-code.php`}>361DM App</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/careers.php`}>Careers</a></li>
           </ul>
           <ul className="about-us">
             <li><a href="javascript:void();"><span>About Us :</span></a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/company-profile.php`} target="_blank" rel="noopener noreferrer">Company profile</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/tech-platform.php`} target="_blank" rel="noopener noreferrer">Tech Platform</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/media-center.php`} target="_blank" rel="noopener noreferrer">Media Centre</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/alumni.php`} target="_blank" rel="noopener noreferrer">Alumni</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/careers.php`} target="_blank" rel="noopener noreferrer">Careers</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/contact-us.php`} target="_blank" rel="noopener noreferrer">Contact Us</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/privacy.php`} target="_blank" rel="noopener noreferrer">Privacy</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/terms.php`} target="_blank" rel="noopener noreferrer">Terms</a></li>
             <li><a href={`${Config.rootDomainUrl}about-us/legal.php`} target="_blank" rel="noopener noreferrer">Legal</a></li>
           </ul>
           <div className="f-social">
             <div className="f-social-ico"> <a href="https://www.facebook.com/361dm" title="Facebook" target="_blank" rel="noopener noreferrer"><img src={process.env.PUBLIC_URL +'/images/foo-fb-ico.png'} alt="Facebook" width="32" height="32"/></a> <a href="https://plus.google.com/s/361DM/top" title="Google+" target="_blank" rel="noopener noreferrer">
             <img src={process.env.PUBLIC_URL +'/images/foo-gplus-ico.png'} alt="Google+" width="32" height="32"/>
             </a>
             <a href="https://twitter.com/361dm" title="Twitter" target="_blank" rel="noopener noreferrer">
             <img src={process.env.PUBLIC_URL +'/images/foo-tw-ico.png'} alt="Twitter" width="32" height="32"/></a>
             <a href="https://www.linkedin.com/company/361-degree-minds?" title="Linkedin" target="_blank" rel="noopener noreferrer">
             <img src={process.env.PUBLIC_URL +'/images/foo-in-ico.png'} alt="Linkedin" width="32" height="32"/></a>
             </div>
           </div>
           <div className="copyright">Copyright © 2017 361Degree Minds Consulting Pvt Ltd</div>
         </div>
       </div>
     </footer>
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/Homefooter.js